import supabaseClient from '@/api/supabaseClient.ts';
import { SubscriptionRepository } from '$/repositories/subscriptionRepository/SubscriptionRepository.ts';

const subscriptionRepository = new SubscriptionRepository(supabaseClient);
export default subscriptionRepository;
